'use client'

import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { updateUserData } from '../reduxToolkit/authSlice'

export default function InitializeAccountData({ accountData }) {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(updateUserData({...accountData}))
  }, [accountData, dispatch])

  return null
}
